export const OFFER_VALIDITY_DAYS = 30;

export const DEFAULT_OFFER_TEXTS = {
  title: "Oferta remontowa",
  includesIntro: "Oferta obejmuje kompleksowy zakres prac niezbędnych do realizacji remontu, w tym:",
  timelineNote: "Harmonogram orientacyjny: termin rozpoczęcia i czas realizacji potwierdzamy po akceptacji oferty, pomiarze oraz uzgodnieniu dostępności materiałów.",
  priceDisclaimer: "Ceny obowiązują w dniu wystawienia oferty.",
  closingLead: "W razie pytań lub chęci dopasowania zakresu — zapraszam do kontakt.",
  closingSecond: "Zakres i ceny można dostosować do Państwa potrzeb.",
};

export function buildValidityAssumption(days = OFFER_VALIDITY_DAYS): string {
  return `Oferta ważna ${days} dni od daty wystawienia`;
}
